import { ClickAwayListener, Popper } from '@mui/material';
import React, { ReactElement, useState, MouseEvent, useEffect } from 'react';
import { useKey } from 'react-use';
import { styles, usePopperStyles } from './styles';
import HeaderIconButton, { IconType } from '../HeaderIconButton';

interface TopBarDropdownContainerProps {
  children: ReactElement;
  title?: string;
  placeHolderCtaText?: string;
  handleClick?: () => Promise<void>;
  filter: string;
  isIcon?: boolean;
}

export default function TopBarDropdownContainer({
  children,
  title,
  placeHolderCtaText,
  handleClick,
  filter,
  isIcon = false,
}: TopBarDropdownContainerProps): JSX.Element {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [ctaText, setCtaText] = useState<string | undefined>(placeHolderCtaText);
  useEffect(() => {
    setCtaText(placeHolderCtaText);
  }, [placeHolderCtaText]);
  const popperClasses = usePopperStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>();
  const onFilterClick = (
    event: MouseEvent<HTMLButtonElement> | MouseEvent<HTMLDivElement>
  ): void => {
    handleClick?.();
    setIsModalOpen(true);
    setAnchorEl(event.currentTarget);
  };

  const onListItemClick = (): void => {
    setIsModalOpen(false);
  };

  useKey('Escape', (): void => {
    setIsModalOpen(false);
  });

  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
    if (e.key === 'Enter') {
      handleClick?.();
      setIsModalOpen(true);
      setAnchorEl(e.currentTarget);
    }
  };

  return (
    <>
      {!isIcon && (
        <button
          className={`${filter}-filter-cta-container`}
          onClick={(e): void => onFilterClick(e)}
        >
          <div className={`${filter}-filter-cta-header`}>{title}</div>
          <div className={`${filter}-filter-cta`}>{ctaText}</div>
        </button>
      )}
      {isIcon && (
        <div
          onClick={(e): void => onFilterClick(e)}
          data-testid="header-icon-button-container"
          role="button"
          tabIndex={0}
          onKeyDown={onKeyDown}
        >
          <HeaderIconButton icon={filter as IconType} />
        </div>
      )}
      {isModalOpen && (
        <ClickAwayListener onClickAway={(): void => setIsModalOpen(false)}>
          <Popper
            style={{ width: filter === 'location' ? '298px' : 'auto' }}
            open={isModalOpen}
            className={popperClasses.root}
            anchorEl={anchorEl}
          >
            {React.cloneElement(children, { onListItemClick })}
          </Popper>
        </ClickAwayListener>
      )}
      <style jsx>{styles}</style>
    </>
  );
}
